import { useEffect, useState } from "react";
import usercategories from "../../../data/usersCategories.json";
import { Button } from "../../../layouts/ui/Button";

export const UsersPage = () => {
  const [enabled, setEnabled] = useState("JobSeekers");
  const [userCategories, setUsercategories] = useState([]);

  const handleToggle = () => {
    const next = enabled === "JobSeekers" ? "Employers" : "JobSeekers";
    setEnabled(next);
    setUsercategories(usercategories[next]);
  };

  useEffect(() => {
    setUsercategories(usercategories["JobSeekers"]);
  }, []);

  return (
    <section className="w-full bg-[#EEF7FF] min-h-[536px] py-10 px-4 sm:px-8 md:px-16 lg:px-24 xl:px-36">
      {/* Heading + Toggle */}
      <div className="flex flex-col md:flex-row lg:felx-row justify-center items-center gap-6 lg:gap-16 text-center md:text-left lg:text-left">
        {/* Job Seekers side */}
        <div
          className={`${enabled === "JobSeekers" ? "text-[#2C25C4]" : "text-gray-400"
            }`}
        >
          <h2 className="text-2xl sm:text-3xl lg:text-[36px] font-bold">
            For Job Seekers
          </h2>
          <h4 className="text-lg sm:text-xl lg:text-[22px] font-semibold">
            Your Career, Simplified
          </h4>
        </div>

        {/* Toggle Switch */}
        <div className="hidden md:block lg:block">
          <button
            onClick={handleToggle}
            className="relative w-16 h-9 flex items-center rounded-full border-[#2C25C4] p-1 border transition-colors duration-300"
          >
            <span
              className={`w-7 h-7 bg-[#2C25C4] rounded-full shadow-md transform transition-transform duration-300 ${enabled === "Employers" ? "translate-x-7" : "translate-x-0"
                }`}
            ></span>
          </button>
        </div>

        {/* Employers side */}
        <div
          className={`${enabled === "Employers" ? "text-[#2C25C4]" : "text-gray-400"
            } hidden md:block lg:block`}
        >
          <h2 className="text-2xl sm:text-3xl lg:text-[36px] font-bold">
            For Employers
          </h2>
          <h4 className="text-lg sm:text-xl lg:text-[22px] font-semibold">
            Smarter Hiring, Faster Results
          </h4>
        </div>
      </div>

      {/* Cards */}
      <div className="flex justify-center gap-2 md:gap-3 lg:gap-5 mt-5 md:mt-10 flex-wrap">
        {userCategories &&
          userCategories.map((user, index) => (
            <div
              key={index}
              className="bg-white rounded-lg w-full sm:w-[220px] md:w-[186px] px-6 py-5 space-y-2 h-auto md:h-[230px] shadow flex flex-col"
            >
              <div className="flex justify-center">
                <img
                  src={user?.icon}
                  alt={user?.Heading}
                  className="w-10 h-10 border rounded-xl"
                />
              </div>
              <h3 className="font-semibold text-base sm:text-lg text-center md:text-left">
                {user.Heading}
              </h3>
              <p className="text-sm text-gray-600 text-center md:text-left">
                {user?.subHeading}
              </p>
            </div>
          ))}
      </div>

      {/* Button */}
      {
        enabled === "JobSeekers" &&
        <div className="flex justify-center mt-10">
          <Button
            onClick={() => window.location.href = '/signup'}
            className="w-[200px] h-[48px] bg-white border border-[#2C25C4] text-[#2C25C4] rounded-[8px]"
            children={"Browse Jobs Now"}
          />
        </div>
      }


      {/*Mobile View JobSeekers*/}
      {/* Employers side */}
      <div className="grid justify-center md:hidden lg:hidden mt-10">
        <div
          className={`text-black  md:hidden lg:hidden`}>
          <h2 className="text-2xl text-center sm:text-3xl lg:text-[36px] font-bold">
            For Employers
          </h2>
          <h4 className="text-lg sm:text-xl text-center lg:text-[22px] font-semibold text-gray-600">
            Smarter Hiring, Faster Results
          </h4>
        </div>

        {/* Cards */}
        <div className="flex justify-center gap-2 md:gap-3 lg:gap-5 mt-5 md:mt-10 flex-wrap">
          {usercategories?.Employers &&
            usercategories?.Employers.map((user, index) => (
              <div
                key={index}
                className="bg-white rounded-lg w-full sm:w-[220px] md:w-[186px] px-6 py-5 space-y-2 h-auto md:h-[230px] shadow flex flex-col"
              >
                <div className="flex justify-center">
                  <img
                    src={user?.icon}
                    alt={user?.Heading}
                    className="w-10 h-10 border rounded-xl"
                  />
                </div>
                <h3 className="font-semibold text-base sm:text-lg text-center md:text-left">
                  {user.Heading}
                </h3>
                <p className="text-sm text-gray-600 text-center md:text-left">
                  {user?.subHeading}
                </p>
              </div>
            ))}
        </div>
      </div>

    </section>
  );
};
